import type { FormEvent } from "react";
import { useEffect, useState } from "react";

import { useSelection } from "@/lib/hooks/useSelection";
import { usePromoMutation } from "@/lib/hooks/useSelection/cart/usePromo";

const useVoucher = () => {
  const { data } = useSelection();
  const vouchers = data?.selection?.discounts;
  const [code, setCode] = useState("");
  const [hasPromo, setHasPromo] = useState(false);
  const [error, setError] = useState("");
  const { promo } = usePromoMutation();

  useEffect(() => {
    if (!vouchers?.anyDiscount) {
      setHasPromo(false);
      setCode("");
    }
  }, [vouchers]);

  useEffect(() => {
    if (promo.isError) {
      setError(promo.error.message);
    } else if (vouchers?.vouchers?.length && !promo.isPending) {
      setCode(vouchers?.vouchers?.[0]?.voucher || "");
      setHasPromo(true);
      setError("");
    }
  }, [promo, vouchers]);

  const add = (e: FormEvent) => {
    e.preventDefault();
    promo.mutate({
      code,
      remove: false,
    });
  };

  const remove = () => {
    promo.mutate({
      code: vouchers?.vouchers?.[0]?.voucher || "",
      remove: true,
    });
  };

  return {
    add,
    remove,
    isLoading: promo.isPending,
    showRemove: hasPromo,
    error: error !== "" ? error : null,
    isValid: !promo.isError && !promo.isPending,
    code: code,
    vouchers: vouchers?.vouchers,
    amount: vouchers?.discount,
    updateCode: (e: React.ChangeEvent<HTMLInputElement>) =>
      setCode(e.target.value),
  };
};

export default useVoucher;
